import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  optionCard: {
    boxShadow: 'none',
    border: `1px solid ${theme.new.color.line.hairline}`,
  },
  optionCardEnabled: {
    cursor: 'pointer',
  },
  optionCardDisabled: {
    backgroundColor: theme.new.color.grey[100],
  },
  optionCardSelected: {
    border: `1px solid ${theme.new.color.brandPrimary}`,
  },
  optionRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.new.spacing.medium,
  },
  cardContent: {
    '&:last-child': {
      paddingBottom: '16px !important',
    },
  },
  radio: {
    padding: '4px',
  },
}));

export default useStyles;
